module.exports = __webpack_public_path__ + "static/media/S-3.af8e069e.mp3";